import { HttpError, errorFields } from '../../../api';
import type { ErrorFactory } from '../../../api';
import { PASSCODE_REFUSALS } from '../types/domain.types';
import type { PasscodeRefusalCode } from '../types/domain.types';

const refusalOf = (code: string | null): PasscodeRefusalCode | null =>
  code !== null && (PASSCODE_REFUSALS as readonly string[]).includes(code) ? (code as PasscodeRefusalCode) : null;

const numberOf = (value: unknown): number | null =>
  typeof value === 'number' && Number.isFinite(value) ? value : null;

export class PasscodeError extends HttpError {
  readonly refusal: PasscodeRefusalCode | null;
  readonly retryAfterSeconds: number | null;
  readonly attemptsLeft: number | null;
  readonly lockSeconds: number | null;

  constructor(opts: {
    status: number;
    message: string;
    code?: string | null;
    retryAfterSeconds?: number | null;
    attemptsLeft?: number | null;
    lockSeconds?: number | null;
  }) {
    super(opts);
    this.name = 'PasscodeError';
    this.refusal = refusalOf(opts.code ?? null);
    this.retryAfterSeconds = opts.retryAfterSeconds ?? null;
    this.attemptsLeft = opts.attemptsLeft ?? null;
    this.lockSeconds = opts.lockSeconds ?? null;
  }
}

export const passcodeErrorFrom: ErrorFactory = (status, data) => {
  const body = (data ?? {}) as Record<string, unknown>;
  return new PasscodeError({
    status,
    ...errorFields(data),
    retryAfterSeconds: numberOf(body.retryAfterSeconds),
    attemptsLeft: numberOf(body.attemptsLeft),
    lockSeconds: numberOf(body.lockSeconds),
  });
};
